import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './steps2.css'

const Steps2 = (props) => {
  return (
    <div className="steps2-container1 thq-section-padding">
      <div className="steps2-max-width thq-section-max-width">
        <div className="steps2-container2 thq-grid-2">
          <div className="steps2-section-header">
            <h2 className="thq-heading-2">
            Why Choose Skill Consultants?
            </h2>
            <p className="thq-body-large">
              <ul>
                <li>Cutting-Edge Technology: We stay ahead of the curve by embracing the latest technologies and trends.</li>
                <li>Experienced Team: Our skilled professionals have a proven track record of delivering successful projects.</li>
                <li>Client-Centric Approach: We prioritize your needs and tailor our solutions to your specific requirements.</li>
                <li>Agile Methodology: We adopt agile development practices to ensure flexibility and responsiveness.</li>
                <li>Data-Driven Insights: We leverage data analytics to make informed decisions and drive business growth.</li>
              </ul>
            </p>
            <div className="steps2-actions">
              {/* <button className="thq-button-filled thq-button-animated steps2-button">
                <span className="thq-body-small">Main action</span>
              </button> */}
            </div>
          </div>
          <div className="steps2-container3">
            <div className="steps2-container4 thq-card">
              <h2>
                {props.step1Title ?? (
                  <Fragment>
                    <h2 className="steps2-text29 thq-heading-2">
                      Initial Consultation
                    </h2>
                  </Fragment>
                )}
              </h2>
              <span>
                {props.step1Description ?? (
                  <Fragment>
                    <span className="steps2-text26 thq-body-small">
                      Schedule a meeting with our team to discuss your project
                      requirements and goals.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text15 thq-heading-3">01</label>
            </div>
            <div className="steps2-container5 thq-card">
              <h2>
                {props.step2Title ?? (
                  <Fragment>
                    <h2 className="steps2-text30 thq-heading-2">
                      Design Concept Creation
                    </h2>
                  </Fragment>
                )}
              </h2>
              <span>
                {props.step2Description ?? (
                  <Fragment>
                    <span className="steps2-text28 thq-body-small">
                      Our designers will create mockups and design concepts
                      based on the information gathered during the consultation.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text18 thq-heading-3">02</label>
            </div>
            <div className="steps2-container6 thq-card">
              <h2>
                {props.step3Title ?? (
                  <Fragment>
                    <h2 className="steps2-text31 thq-heading-2">
                      Feedback and Revisions
                    </h2>
                  </Fragment>
                )}
              </h2>
              <span>
                {props.step3Description ?? (
                  <Fragment>
                    <span className="steps2-text32 thq-body-small">
                      Receive the initial design drafts, provide feedback, and
                      request any necessary revisions to ensure the design meets
                      your expectations.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text21 thq-heading-3">03</label>
            </div>
            <div className="steps2-container7 thq-card">
              <h2>
                {props.step4Title ?? (
                  <Fragment>
                    <h2 className="steps2-text25 thq-heading-2">
                      Final Delivery
                    </h2>
                  </Fragment>
                )}
              </h2>
              <span>
                {props.step4Description ?? (
                  <Fragment>
                    <span className="steps2-text27 thq-body-small">
                      Once the design is approved, we will deliver the final
                      user interface design files for your website.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text24 thq-heading-3">04</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Steps2.defaultProps = {
  step4Title: undefined,
  step1Description: undefined,
  step4Description: undefined,
  step2Description: undefined,
  step1Title: undefined,
  step2Title: undefined,
  step3Title: undefined,
  step3Description: undefined,
}

Steps2.propTypes = {
  step4Title: PropTypes.element,
  step1Description: PropTypes.element,
  step4Description: PropTypes.element,
  step2Description: PropTypes.element,
  step1Title: PropTypes.element,
  step2Title: PropTypes.element,
  step3Title: PropTypes.element,
  step3Description: PropTypes.element,
}

export default Steps2
